import axios from 'axios';

export const deleteSwrFetcherWithDynamicUrl = async <T>(url: string, { arg }: { arg: { urlSuffix: string } }) => {
  const response = await axios.delete<T>(`${url}${arg.urlSuffix}`);

  return response.data;
};
